import axios from "axios"
import { LOCAL_TOKEN } from "./storage"

/**
 *
 * No cambiar este sin previo aviso!
 *
 * */

window.fetchGlobalApi = ({
  method,
  endpoint = "",
  params = {},
  data = {},
  ...rest
}) => {
  return axios.request({
    method,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}${endpoint}`,
    params,
    data,
    ...rest,
  })
}
